/**
 * A porta de entrada. Um campo só.
 *
 * Não tem "criar conta", não tem "esqueci a senha", não tem senha. Quem entra
 * é quem o gestor cadastrou e para quem o gestor gerou um código. O link deste
 * app pode ser compartilhado com o mundo inteiro que continua não sendo porta
 * de entrada para ninguém.
 *
 * O código é digitado UMA vez por aparelho. Depois disso o celular fica
 * reconhecido por seis meses — o tratador não pode ser deslogado no meio do
 * campo, sem sinal, com a mão molhada.
 */

import { useState } from 'react'
import { ConexaoFalhou, entrar, ErroDoServidor, SemSinal, type Eu } from '../acesso/api'

/** Põe o traço sozinho e maiusculiza: quem cola do WhatsApp e quem digita à
 *  mão chegam no mesmo lugar. */
function formatar(bruto: string): string {
  const limpo = bruto.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8)
  return limpo.length > 4 ? `${limpo.slice(0, 4)}-${limpo.slice(4)}` : limpo
}

export function Entrada({ aoEntrar }: { aoEntrar: (eu: Eu) => void }) {
  const [codigo, setCodigo] = useState('')
  const [erro, setErro] = useState<string | null>(null)
  const [enviando, setEnviando] = useState(false)

  const completo = codigo.replace(/[^A-Z0-9]/g, '').length === 8

  async function enviar(evento: React.FormEvent) {
    evento.preventDefault()
    if (enviando || !completo) return

    setEnviando(true)
    setErro(null)
    try {
      aoEntrar(await entrar(codigo))
    } catch (falha) {
      if (falha instanceof ConexaoFalhou) {
        // O código pode ter sido gasto no servidor e a resposta ter se perdido:
        // nesse caso a próxima tentativa dá «código inválido», e não é engano.
        setErro(
          'Conexão falhou. A primeira entrada do aparelho precisa de sinal. Se na próxima' +
            ' tentativa o código for recusado, peça um novo ao gestor.',
        )
      } else if (falha instanceof SemSinal) {
        setErro('Não há conexão. A primeira entrada do aparelho precisa de sinal.')
      } else if (falha instanceof ErroDoServidor) {
        setErro(falha.message)
      } else {
        setErro('Não deu para entrar. Tente de novo.')
      }
      setEnviando(false)
    }
  }

  return (
    <main className="entrada">
      <h1 className="entrada-titulo">Piscicultura Cunhataí</h1>
      <p className="entrada-texto">
        Digite o código que o gestor enviou. É uma vez só neste aparelho.
      </p>

      <form onSubmit={enviar}>
        <label className="campo">
          <span className="campo-rotulo">Código de acesso</span>
          <input
            className="entrada-codigo"
            value={codigo}
            onChange={(e) => setCodigo(formatar(e.target.value))}
            placeholder="XXXX-XXXX"
            autoComplete="one-time-code"
            autoCapitalize="characters"
            autoCorrect="off"
            spellCheck={false}
            enterKeyHint="go"
          />
        </label>

        {erro && <p className="aviso-erro">{erro}</p>}

        <button className="botao-grande" type="submit" disabled={!completo || enviando}>
          {enviando ? 'Conferindo…' : 'Entrar'}
        </button>
      </form>

      <p className="entrada-rodape">
        Não tem código? Peça ao gestor da fazenda. Não existe cadastro por conta
        própria.
      </p>
    </main>
  )
}
